import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest } from "redux-saga/effects";
import { IDeleteIapRequest } from "../intefaces/IIap";
import {
  deleteIap,
  deleteIapSuccess,
  getIapFailure,
  getIaps,
  getIapSuccess,
} from "../reducers/iapSlice";
import * as iapService from "../services/iapService";

function* IapSaga() {
  function* getIapList(action) {
    try {
      let response = yield iapService.getIaps(action.payload);
      if (response.status) {
        return yield put(getIapSuccess(response));
      }
      throw new Error(response.message);
    } catch (error) {
      yield put(getIapFailure(error.message));
    }
  }

  function* deleteIapSaga(action: PayloadAction<IDeleteIapRequest>) {
    try {
      let response: any = yield iapService.deleteIap(action.payload);
      if (response.status) {
        return yield put(deleteIapSuccess(action.payload));
      }
      throw new Error(response.message);
    } catch (error) {
      yield put(getIapFailure(error.message));
    }
  }

  yield takeLatest(deleteIap.type.toString(), deleteIapSaga);
  yield takeLatest(getIaps.type.toString(), getIapList);
}

export default IapSaga;
